/**
 * Single generic Cloudinary upload helper for the admin client.
 *
 * Every upload goes through the backend (POST /cloudinary/upload). The backend
 * prefixes every upload with the brand folder taken from the appConfigurations
 * collection (brandName key), so the client never needs to know the brand,
 * the Cloudinary cloud name, or any upload preset.
 *
 * `folder` is the path RELATIVE to the brand folder (e.g. 'Campaigns' or
 * `${businessId}/services`). Leave it empty to upload into the brand root.
 *
 * Returns the Cloudinary upload result JSON verbatim (secure_url, public_id,
 * original_filename, url, ...). On failure it resolves with
 * { success: false, error } instead of throwing, matching how the previous
 * direct-to-Cloudinary calls behaved.
 */
export const uploadToCloudinary = async (file, { folder = '', publicId = '' } = {}) => {
    try {
        const formData = new FormData();
        formData.append('file', file);
        if (folder) formData.append('folder', folder);
        if (publicId) formData.append('public_id', publicId);

        const response = await fetch('/cloudinary/upload', {
            method: 'POST',
            body: formData
        });
        return await response.json();
    } catch (err) {
        console.error('Error uploading to Cloudinary via server:', err.message);
        return { success: false, error: err.message };
    }
};

const cloudinaryService = { uploadToCloudinary };
export default cloudinaryService;
